// extracted by mini-css-extract-plugin
export default {"page":"Fh-z","cartModal":"Gh-z","checkout":"Hh-z","placeholder":"Ih-z","account":"Jh-z"};